// TODO make property dynamic

export type Routes = { name: string; path: string; showInMenu?: boolean }[];

const routes: Routes = [{ name: 'Home', path: '/', showInMenu: true }];
const mainNavigation = routes.filter(({ showInMenu }) => showInMenu) as Routes;

export { mainNavigation };
export default routes;
